// extracted by mini-css-extract-plugin
export default {"pageWrap":"Dd-z","fullWidth":"Ed-z","heading":"Fd-z","fullBleed":"Gd-z","hidden":"Hd-z"};